import { render, staticRenderFns } from "./mifi.vue?vue&type=template&id=670c762e&"
import script from "./mifi.vue?vue&type=script&lang=js&"
export * from "./mifi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports